<template>
  <van-cell-group inset>
    <van-field
        v-html="license"
        rows="1"
        autosize
        label="留言"
        type="textarea"
        placeholder="请输入留言"
    />
  </van-cell-group>
</template>

<script>
export default {
  name: "UserLicense",
  data(){
    return{
      license:'&emsp;&emsp;青岛海鲲蓝宇科技有限公司重视您的隐私。为了给您提供更准确、更有个性化的服务，您在使用我们的服务时，我们可能会收集和使用您的信息。我们希望通过本《隐私政策》' +
          '向您说明在您使用我们的服务时，我们如何收集、使用、储存和分享这些信息，' +
          '以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的服务息息相关，我们也希望您能够仔细阅读，并在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》之中涉及的相关技术词汇，我们尽量以简明扼要的表述向您解释，以便您的理解。\n' +
          '您使用或继续使用我们的服务，都表示您同意我们按照本《隐私政策》收集、使用、储存和分享您的信息。\n<br/>' +
          '&emsp;&emsp;如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，请通过发送电子邮件至haikunlanyu@126.com与我们联系。\n<br/>' +
          '\n' +
          '一、我们收集的信息\n<br/>' +
          '&emsp;&emsp;我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户、享受我们提供的某些服务，或者即便我们可以继续向您提供一些服务，也无法达到该服务拟达到的效果。 \n<br/>' +
          '1.您提供的信息\n<br/>' +
          '1）您在使用功能之前，向我们提供的相关个人信息，例如电话号码等；\n<br/>' +
          '2）您通过我们的服务进行相关业务操作时，以及您使用我们的服务时所储存的信息。\n<br/>' +
          '2.我们获取的您的信息\n<br/>' +
          '您使用我们服务时，系统可能会通过一定方式自动采集技术信息，包括：\n<br/>' +
          '1）设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码；\n<br/>' +
          '2）有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；\n<br/>' +
          '二、我们如何使用您的信息\n<br/>' +
          '&emsp;&emsp;我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：\n<br/>' +
          '1.向您提供服务；\n<br/>' +
          '2.在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；\n<br/>' +
          '3.帮助我们设计新服务，改善我们现有服务；\n<br/>' +
          '4.软件认证或管理软件升级；\n<br/>' +
          '5.让您参与有关我们产品和服务的调查。\n<br/>' +
          '针对某些特定服务的特定隐私政策将更具体地说明我们在该等服务中如何使用您的信息。\n<br/>' +
          '三、如何访问和控制您的信息\n<br/>' +
          '&emsp;&emsp;我们将尽量采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。\n<br/>' +
          '四、我们如何分享您的信息\n<br/>' +
          '&emsp;&emsp;除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：\n<br/>' +
          '1.向您提供我们的服务；\n<br/>' +
          '2.实现“我们如何使用您的信息”部分所述目的；\n<br/>' +
          '3.履行我们在本《隐私政策》中的义务和行使我们的权利；\n<br/>' +
          '4.理解、维护和改善我们的服务。\n<br/>' +
          '如我们或我们的关联公司与任何第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及  我们要求其遵守的其他适当的保密和安全措施。\n<br/>' +
          '5.我们或我们的关联公司还可能为以下需要保留、保存或披露您的个人信息：\n<br/>' +
          '1）遵守适用的法律法规；\n<br/>' +
          '2）遵守法院命令或其他法律程序的规定；\n<br/>' +
          '3）遵守相关政府机关的要求；\n<br/>' +
          '4）我们认为为遵守适用的法律法规、维护社会公共利益，或保护我们、我们的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的。\n<br/>' +
          '五、我们如何保留、储存和保护您的信息\n<br/>' +
          '1.我们仅在本《隐私政策》所述目的所必需期间和法律法规要求的时限内保留您的个人信息。\n<br/>' +
          '2.我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您向我们提供的个人信息。但请您谅解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。\n<br/>' +
          '3.您同意您的敏感个人信息按本《隐私政策》所述的目的和方式来处理。\n<br/>' +
          '六、本《隐私政策》的适用范围\n<br/>' +
          '&emsp;&emsp;除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。该特定服务的隐私政策构成本《隐私政策》的一部分。如任何特定服务的隐私政策与本《隐私政策》有不一致之处，则适用特定服务的隐私政策。\n<br/>' +
          '七、本《隐私政策》的修改\n<br/>' +
          '&emsp;&emsp;我们可能随时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。如该等修改造成您在本《隐私政策》下权利的实质减少，我们将在修改生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您，在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/user/UserLicense.vue